import React from 'react'
import './LegalDocumentsFirstSection.scss'
import UnifiedButton from '../../shared/Button'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

function LegalDocumentsFirstSection() {
    const navigate = useNavigate()

    const handleJoinClick = () => {
        console.log('Navigating to /pricing');
        navigate('/pricing/1');
        //window.scrollTo(0, 0);
    };
    return (
        <section className="about-section">
            <div className="about-content">
                <Typography variant='h4'>Legal Documents</Typography>
                <Typography>Explore the history of FM Digital Official and the inspiration behind its founding.</Typography>
                <UnifiedButton className="cta-button" textContent={'Join Us here'} onClick={handleJoinClick} />
            </div>
        </section>
    )
}

export default LegalDocumentsFirstSection
